"use client";
import React from "react";
import {
  COMPANY_ADDRESS_FULL,
  COMPANY_INFO_EMAIL,
} from "@/constants/sleapContact";
import { useTranslations } from "next-intl";

const TermsAndConditions = () => {
  const t = useTranslations("TermsConditions");

  return (
    <div className="container py-12">
      <h3 className="pb-6 text-transparent bg-clip-text bg-gradient-to-r from-primary via-secondary to-secondary">
        {t("heading")}
      </h3>

      <div className="flex flex-col gap-6 bg-lightwhite dark:bg-sleap-gray-950">
        <p>{t("lastUpdated", { date: "16.12.2024" })}</p>

        <p>{t("intro")}</p>

        <h4>{t("sections.definitions.title")}</h4>
        {t.raw("sections.definitions.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.generalConditions.title")}</h4>
        {t
          .raw("sections.generalConditions.points")
          .map((p: string, i: number) => (
            <p key={i}>{p}</p>
          ))}

        <h4>{t("sections.platformUse.title")}</h4>
        {t.raw("sections.platformUse.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.sanctions.title")}</h4>
        {t.raw("sections.sanctions.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.giveaways.title")}</h4>
        {t.raw("sections.giveaways.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.bookingTerms.title")}</h4>
        {t.raw("sections.bookingTerms.points").map((p: string, i: number) => (
          <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
        ))}

        <h4>{t("sections.intellectualProperty.title")}</h4>
        {t
          .raw("sections.intellectualProperty.points")
          .map((p: string, i: number) => (
            <p key={i}>{p}</p>
          ))}

        <h4>{t("sections.liability.title")}</h4>
        {t.raw("sections.liability.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.privacy.title")}</h4>
        {t.raw("sections.privacy.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.termination.title")}</h4>
        {t.raw("sections.termination.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.modifications.title")}</h4>
        {t.raw("sections.modifications.points").map((p: string, i: number) => (
          <p key={i}>{p}</p>
        ))}

        <h4>{t("sections.contact.title")}</h4>
        <p>{t("sections.contact.description")}</p>
        <p>
          {t("sections.contact.emailLabel")}{" "}
          <a
            href={`mailto:${COMPANY_INFO_EMAIL}`}
            className="text-primary hover:underline"
          >
            {COMPANY_INFO_EMAIL}
          </a>
          <br />
          {t("sections.contact.addressLabel")} {COMPANY_ADDRESS_FULL}
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
